<template>
  <div>
    <!-- SP時チェックボックス -->
    <div
      v-if="isSpRadioButton && isSpWidth"
      class="row form-check mb-1"
    >
      <div
        v-for="(option, index) in options"
        :key="index"
        :class="spWrapClass"
      >
        <input
          :id="`select-${_uid}-${index}`"
          type="radio"
          :name="postName"
          class="form-check-input"
          :value="convertValue(option)"
          :checked="clicked == convertLabel(option)"
          @change="select(option)"
        />
        <label
          :for="`select-${_uid}-${index}`"
          class="form-check-label"
        >
          {{ convertLabel(option) }}
        </label>
      </div>
    </div>
    <!-- PCボタン -->
    <div
      v-else
      class="btn-list text-left"
      :class="[
        btnListMarginClass,
        {
          'round-radio-buttons': buttonType == 'round',
          'tile-radio-buttons': buttonType == 'tile',
          'disabled': disabled,
        }
      ]"
      data-toggle="buttons"
    >
      <v-button
        v-for="(option, index) in options"
        ref="SingleVBtn"
        :key="convertLabel(option)"
        :button-class="buttonClass"
        :button-id="String(index)"
        :button-label="convertLabel(option)"
        :post-name="postName"
        :clicked="clicked == convertLabel(option)"
        :button-value="convertValue(option)"
        :is-wrap="isWrap"
        @select="select(option)"
      />
    </div>
  </div>
</template>

<script>
import VButton from "./VButton.vue";

export default {
  components: {
    VButton
  },
  props: {
    btnListMarginClass: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    optionKey: {
      type: String,
      default: "undefined"
    },
    valueKey: {
      type: String,
      default: "undefined"
    },

    // ボタンの形 角丸=tile 丸=round
    buttonType: {
      type: String,
      default: "tile"
    },
    buttonClass: {
      type: String,
      default: ""
    },
    postName: {
      type: String,
      default: "single_selected"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clicked: {
      type: String,
      default: ""
    },
    isWrap: {
      type: Boolean,
      default: false
    },
    isSpRadioButton: {
      type: Boolean,
      default: false
    },
    spWrapClass: {
      type: String,
      default: "mb-3 col-12 d-inline-block"
    }
  },
  data() {
    return {
      innerWidth: window.innerWidth
    };
  },
  computed: {
    isSpWidth() {
      return this.innerWidth < 768;
    }
  },
  mounted() {
    window.addEventListener("resize", this.calcWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWindowWidth);
  },
  methods: {
    calcWindowWidth() {
      this.innerWidth = window.innerWidth;
    },
    convertLabel(option) {
      if (this.optionKey === "undefined") {
        return String(option);
      }
      return String(option[this.optionKey]);
    },
    convertValue(option) {
      if (this.valueKey === "undefined") {
        return String(option);
      }
      return String(option[this.valueKey]);
    },
    select(option) {
      this.$emit("select", option);
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .btn-list {
    display: inline-flex;
    flex-wrap: wrap;
  }
}
.form-check {
  padding-left: 0 !important;

  label::before {
    background: #F7F8FA;
    border: 1px solid #DBDEE1 !important;
  }
}
</style>
